function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgVimeo = function SvgVimeo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.999 299.999",
    style: {
      enableBackground: "new 0 0 299.999 299.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", {
    id: "XMLID_518_"
  }, React.createElement("path", {
    id: "XMLID_3_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M298.723,68.78c2.238-12.561,2.188-25.477-5.57-35.245 c-10.824-13.696-33.863-14.2-49.646-11.783c-12.84,1.963-56.269,21.124-71.047,66.996c26.182-1.99,39.904,1.887,37.385,30.713 c-1.055,12.061-7.148,25.274-13.947,37.941c-7.857,14.603-22.583,43.277-41.894,22.608c-17.394-18.602-16.088-54.179-20.065-77.871 c-2.215-13.292-4.557-29.857-8.912-43.529c-3.753-11.757-12.359-25.932-22.884-29.004c-11.304-3.322-25.28,1.863-33.487,6.698 C42.522,51.661,22.605,73.513,0,91.54l0,0c3.68,7.884,5.687,12.992,12.283,13.949c15.561,2.292,30.391-14.502,40.736,2.971 c6.294,10.675,8.26,22.381,12.287,33.891c5.387,15.328,9.541,32.02,13.947,49.646c7.452,29.857,16.618,74.47,42.424,85.398 c13.166,5.591,32.957-1.889,42.977-7.831c27.14-16.061,48.289-39.348,66.391-63.04C272.434,150.453,295.27,86.933,298.723,68.78z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVimeo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vimeo.0efe67fe.svg";
export { ForwardRef as ReactComponent };